var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "semantic-ui-react";
/**
 * Extends semantic UI button with basic async handling.
 * Will disable the button and show a spinner until the `onClick` callback settles.
 * Prevents double-clicking from making duplicate API calls, and provides feedback
 * to the user the request is in progress.
 * The `disabled` and `loading` attributes can still be set so a button can still
 * be disabled while the user hasn't finished filling out a form, for example.

 * @example
 * const fakeApiCall = () => new Promise(resolve => setTimeout(resolve, 1000));
 * <AsyncButton basic color='orange' onClick={() => fakeApiCall()}>
 *     I will be spinning and disabled for 1 second
 * </AsyncButton>
 * @param onClick
 * @param buttonProps
 * @return {JSX.Element}
 * @constructor
 */
export function AsyncButton(_a) {
    var { onClick } = _a, buttonProps = __rest(_a, ["onClick"]);
    const [inFlight, setInFlight] = useState(false);
    const loading = inFlight || buttonProps.loading;
    const disabled = inFlight || buttonProps.disabled;
    const handleClick = (...args) => __awaiter(this, void 0, void 0, function* () {
        setInFlight(true);
        try {
            yield (onClick === null || onClick === void 0 ? void 0 : onClick(...args));
        }
        finally {
            setInFlight(false);
        }
    });
    return _jsx(Button, Object.assign({}, buttonProps, { onClick: handleClick, disabled: disabled, loading: loading }));
}
